import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";

const TextInput = forwardRef(
  (
    { type, onErrorCheck, control, name, onEmailCheck, getValues, _onChange, ...props },
    ref
  ) => {
    const handleChange = async (event, onChange) => {
      let value = event.target.value;

      // Enforce numeric-only input for type "number" and limit to 6 characters
      if (type === "number" && name === "sixDigitPIN") {
        value = value.replace(/\D/g, "").slice(0, 6); // Remove non-numeric characters and limit to 6 digits
      }

      // Update form value with react-hook-form onChange
      onChange(value);


      if(_onChange)
        _onChange(value);

      if (type === "email") {
        // Invalid email address error
        if (!event.target.checkValidity()) {
          onEmailCheck({
            type: "invalidFormat",
            message: "Invalid email format",
          });
        } else {
          onEmailCheck(null); // No error
        }
      }
    };

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                fontSize: "16px",
                borderRadius: "25px",
                color: "black", // Set the input text color to black
                backgroundColor: "white", // Set background color to white
                "& fieldset": {
                  borderColor: "#ccc", // Default border color
                },
                "&:hover fieldset": {
                  borderColor: "#999", // Border color on hover
                },
              },
            }}
            error={Boolean(onErrorCheck || error)}
            helperText={  typeof onErrorCheck === "string" ? onErrorCheck : error?.message || ""}
            inputRef={ref}
            type={type}
            value={value || ""}
            onChange={(e) => handleChange(e, onChange)} // Pass the onChange from react-hook-form
            InputProps={{
              inputProps: {
                min: type === "number" ? 0 : undefined,
              },
            }}
            multiline={
              name === "eventCategoryDescription" ||
              name === "description" ||
              name === "event_name" ||
              name === "event_desc" ||
              name === "terms_and_conditions" ||
              name === "termsAndCondition" ||
              name === "message"
            }
            rows={4}
          />
        )}
      />
    );
  }
);

TextInput.propTypes = {
  type: PropTypes.string,
  onErrorCheck: PropTypes.string,
  onEmailCheck: PropTypes.func,
};
export default TextInput;
